import $ from 'jquery';

function showMore() {
	$('.js-reviews-item').each(function() {
		if ($(window).width() >= 1024 && $(this).find('.js-reviews-text').height() > 190) {
			$(this).addClass('more');
		} else if ($(window).width() < 1024 && $(this).find('.js-reviews-text').height() > 118) {
			$(this).addClass('more');
		} else {
			$(this).removeClass('more');
		}
	});
}

$(document).ready(function() {
	if ($('.js-reviews-item').length > 0) {
		showMore();
		$(window).on('resize', function() {
			showMore();
		});
	}
	$(document).on('click', '.js-reviews-item-more', function() {
		$(this).parents('.js-reviews-item').find('.js-reviews-text').addClass('show');
		$(this).hide();
	});
});


// WEBPACK FOOTER //
// ./src/js/pages/reviews/reviews.js